import React, { useEffect, useState } from 'react';
import { getRequest } from '../../apis/functions';
import APIS from '../../apis/routes';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Card from '../../common/Card';

export default function Dashboard() {
    const [data, setData] = useState(0);
    const nav = useNavigate();

    const fetchData = async () => {
        try {
            const result = await getRequest(APIS.DASHBOARD);
            if (!result.data.status) {
                if (result.data.code === 203) {
                    localStorage.clear();
                    nav('/login');
                    toast.error('Session expired, please login again');
                }
            } else {
                setData(result.data.data);
                // Data fetched successfully
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className="pagetitle">Dashboard</div>

            <div className="row mt-5">
                <Card Provider={"Users"} number={data ?? 0} />
            </div>
        </>
    );
}